import Swal from 'sweetalert2';

const showSwal = (type,text="", options = {}) => {
    const defaults = {
        title: type === 'success' ? 'Success!' : 'Oops...',
        text,
    };

    // Merge default options with custom options
    const mergedOptions = { ...defaults, ...options };

    switch (type) {
        case 'success':
            return Swal.fire({
                icon: 'success',
                ...mergedOptions,
            });

        case 'error':
            return Swal.fire({
                icon: 'error',
                ...mergedOptions,
            });

        case 'warning':
            return Swal.fire({
                icon: 'warning',
                title: 'Warning',
                ...mergedOptions,
            });

        case 'info':
            return Swal.fire({
                icon: 'info',
                title: 'Information',
                ...mergedOptions,
            });

        case 'question':
            return Swal.fire({
                icon: 'question',
                title: 'Are you sure?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                ...mergedOptions,
            });

        case 'confirm':
            return Swal.fire({
                icon: 'question',
                title: 'Confirmation',
                text: 'Are you sure you want to proceed?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                ...mergedOptions,
            });

        default:
            return Swal.fire(mergedOptions);
    }
};

export default showSwal